<template>
  <span>Administration Espace Salarié</span>
</template>

<script>
export default {};
</script>

<style>
</style>
